
// Object.defineProperty(exports, "__esModule", {
//     value: true
// });
// exports.utils = void 0;

const hostName = typeof window !== "undefined" &&
    (window.location.hostname !== "localhost") ?
    'https://shopping-cart-5-server.onrender.com' : ''




const utils =
{
    constants: {
        // user: {
        //     // userInfo: {
        //     //     googleID: 'googleID',
        //     //     emailID: 'emailID',     // email associate with userID
        //     //     name: 'name',
        //     //     userImg: 'userImg'
        //     // },
        //     // postal: {
        //     //     p_address: 'p_address',
        //     //     p_name: 'p_name',
        //     //     p_email: 'p_email'   // email associate with delivery
        //     // },
        //     // cookie: {
        //     //     COOKIE_USER_INFO: 'COOKIE_USER_INFO'
        //     // }

        // },
        API: {
            AUTH: hostName + '/auth',
            API_PRODUCTS: hostName + '/api/products',
            API_ORDERS: hostName + '/api/orders',
            API_USERS: hostName + '/api/users',
            USERS: {
                LOGIN: hostName + '/login',
            }
        },
        order: {
            None: 'None',
            Latest: 'Latest',
            lowest: 'Lowest',
            Highest: 'Highest'
        },
        // filter:cSize
        cSizes: ['ALL', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
        localStorage_cart: 'cartItems',



        S3_imgBaseURL: 'https://shopping-cart-x.s3.eu-central-1.amazonaws.com/seller-media/',


        PRODUCT_LIST_REQUEST: 'PRODUCT_LIST_REQUEST',
        PRODUCT_LIST_SUCCESS: 'PRODUCT_LIST_SUCCESS',
        PRODUCT_LIST_FAIL: 'PRODUCT_LIST_FAIL',

        PRODUCT_SELLER_NEW_REQUEST: 'PRODUCT_SELLER_NEW_REQUEST',
        PRODUCT_SELLER_NEW_SUCCESS: 'PRODUCT_SELLER_NEW_SUCCESS',
        PRODUCT_SELLER_NEW_FAIL: 'PRODUCT_SELLER_NEW_FAIL',



        PRODUCT_BY_TXT_SEARCH: "PRODUCT_BY_TXT_SEARCH",
        FILTER_PRODUCT_BY_SIZE: 'FILTER_PRODUCT_BY_SIZE',
        ORDER_PRODUCT_BY_PRICE: 'ORDER_PRODUCT_BY_PRICE',
        COUNT_PRODUCT_INCREASE_OR_REMOVE: 'COUNT_PRODUCT_INCREASE_OR_REMOVE',

        CART_ITEMS_ADD: 'CART_ITEMS_ADD',
        CART_ITEMS_REMOVE: 'CART_ITEMS_REMOVE',

        ORDER_CREATE_REQUEST: 'ORDER_CREATE_REQUEST',
        ORDER_CREATE_SUCCESS: 'ORDER_CREATE_SUCCESS',
        ORDER_CREATE_SUCCESS_CLEAT_CART: 'ORDER_CREATE_SUCCESS_CLEAT_CART',

        ORDER_LIST_REQUEST: 'ORDER_LIST_REQUEST',
        ORDER_LIST_SUCCESS: 'ORDER_LIST_SUCCESS',

        ORDER_DELETE_REQUEST: 'ORDER_DELETE_REQUEST',
        ORDER_DELETE_SUCCESS: 'ORDER_DELETE_SUCCESS',

        ORDER_CLEAR: 'ORDER_CLEAR',
        ORDER_ACTION_FAIL: 'ORDER_ACTION_FAIL',

        USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
        USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
        USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',

        USER_LOGOUT_REQUEST: 'USER_LOGOUT_REQUEST',

        USER_LIST_REQUEST: 'USER_LIST_REQUEST',
        USER_LIST_SUCCESS: 'USER_LIST_SUCCESS',
        USER_LIST_FAIL: 'USER_LIST_FAIL',

        USER_ADMIN_SAVE_REQUEST: 'USER_ADMIN_SAVE_REQUEST',
        USER_ADMIN_SAVE_SUCCESS: 'USER_ADMIN_SAVE_SUCCESS',
        USER_ADMIN_SAVE_FAIL: 'USER_ADMIN_SAVE_FAIL',

        MENU_TOGGLE: 'MENU_TOGGLE',
        MENU_OPEN: 'MENU_OPEN',
        LOGINS_OPENER: 'LOGINS_OPENER',
        MSG_MODAL_OPENER: 'MSG_MODAL_OPENER',

    },
    formateCurrency: (number) => {
        return `$ ${Number(number.toFixed(2))} `
    },

    titleCase(title) {
        title = title.toLowerCase();
        const words = title.split(' ');
        const titleCaseWords = words.map((word) => word[0].toUpperCase() + word.substring(1));
        return titleCaseWords.join(' ');
    },

    // get_token_headers(getState) {

    //     //console.log('getState().reducer_user.user:', getState().reducer_user.user)
    //     //console.log('getState().reducer_user.user.googleTokenID:', getState().reducer_user.user.googleTokenID)

    //     return {
    //         headers: { Authorization: "Bearer " + getState().reducer_user.user.googleTokenID },
    //     };
    // },

    // get_API_error(error) {
    //     const message =
    //         error.response && error.response.data.message
    //             ? error.response.data.message
    //             : error.message;
    //     return message;
    // }

};

exports.utils = utils;
// module.exports = utils;